import React, { memo } from "react";
import Modal from "../../Components/Modal";
import Icon from "@mdi/react";
import { Line } from "react-chartjs-2";
import DatePicker from "react-datepicker2";
import { mdiClose } from "@mdi/js";
import { CircularProgress } from "@mui/material";
import ShowError from "../UI/ShowError/ShowError";

const ChartView = (props) => {
  const {
    openModal,
    handleCloseModal,
    startDate,
    setStartDate,
    EndDate,
    setEndDate,
    handleDate,
    chartData,
    loading,
    dateError,
  } = props;

  return (
    <Modal open={openModal} handleCloseModal={handleCloseModal}>
      {dateError && (
        <ShowError style={{ top: -80, right: 0 }} type="error">
          تاریخ را به درستی وارد کنید
        </ShowError>
      )}
      <div className="chart-container">
        <Icon
          style={{
            position: "absolute",
            top: 15,
            right: 15,
            cursor: "pointer",
            zIndex: 10,
          }}
          path={mdiClose}
          title="close"
          size={1}
          rotate={90}
          color="#000"
          onClick={handleCloseModal}
        />
        <div className="datepiker-container">
          <div className="datepiker-box">
            <p>تاریخ شروع </p>
            <DatePicker
              value={startDate}
              onChange={(value) => setStartDate(value)}
              calendarClass="calender-datepiker"
              className="input-datepiker"
              isGregorian={false}
              timePicker={false}
            />
          </div>
          <div className="datepiker-box">
            <p>تاریخ پایان</p>
            <DatePicker
              value={EndDate}
              onChange={(value) => setEndDate(value)}
              calendarClass="calender-datepiker"
              className="input-datepiker"
              isGregorian={false}
              timePicker={false}
            />
          </div>
        </div>
        <div className="accept-datepiker-container">
          <button onClick={handleDate}>ثبت</button>
        </div>
        <div
          style={{
            height: 350,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : (
            <Line className="chart-style" {...chartData} />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default memo(ChartView);
